import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Package, ShoppingBag, Film, MessageSquare, Plus, LogOut, Clock, CheckCircle2, Video } from "lucide-react";
import { Logo } from "@/components/Logo";

const products = [
  { id: 1, name: "Showty Velvet Lip Tint", desc: "Exclusive new-launch matte lip tint in 3 shades.", img: "/images/brand-products.webp", barter: "2 TikTok videos + Instagram owning content", stock: 25 },
  { id: 2, name: "Showty Glow Serum", desc: "Brightening niacinamide serum, PR sample.", img: "/images/event-1.webp", barter: "2 TikTok + IG owning content", stock: 40 },
  { id: 3, name: "Showty Cushion Foundation", desc: "Long-wear cushion, new drop.", img: "/images/event-3.webp", barter: "2 TikTok + IG owning content", stock: 30 },
];

export default function DemoKOL() {
  return (
    <div className="min-h-screen bg-showty-cream showty-grain">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-showty-cream/85 border-b border-border">
        <div className="max-w-6xl mx-auto px-6 h-18 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Logo className="w-10 h-10" />
            <div>
              <p className="font-display text-xl leading-none text-showty-navy">Showtynion</p>
              <p className="text-[11px] tracking-widest uppercase text-muted-foreground mt-0.5">Beauty Creator</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <img src="https://i.pravatar.cc/150?img=45" alt="" className="w-9 h-9 rounded-full object-cover border border-border" />
            <div className="hidden sm:block text-right">
              <p className="text-sm font-medium text-showty-navy leading-none">Kayla Putri</p>
              <p className="text-xs text-muted-foreground mt-0.5">kolshowty@gmail.com</p>
            </div>
            <Button variant="ghost" size="sm" className="text-muted-foreground"><LogOut className="w-4 h-4" /></Button>
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-6 py-10">
        <div className="mb-8">
          <h1 className="font-display text-4xl text-showty-navy">Beauty Creator Studio</h1>
          <p className="mt-2 text-sm text-muted-foreground max-w-2xl">Request sample eksklusif Showty & submit min. 2 video TikTok + Instagram owning content untuk approval.</p>
        </div>

        <Tabs defaultValue="samples">
          <TabsList className="bg-showty-secondary">
            <TabsTrigger value="samples"><Package className="w-4 h-4 mr-1.5" /> Sample</TabsTrigger>
            <TabsTrigger value="requests"><ShoppingBag className="w-4 h-4 mr-1.5" /> Request Saya</TabsTrigger>
            <TabsTrigger value="submissions"><Film className="w-4 h-4 mr-1.5" /> Video Saya</TabsTrigger>
            <TabsTrigger value="forum"><MessageSquare className="w-4 h-4 mr-1.5" /> Chat Admin</TabsTrigger>
          </TabsList>

          <TabsContent value="samples" className="mt-6">
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {products.map((p) => (
                <div key={p.id} className="rounded-2xl border border-border bg-white overflow-hidden flex flex-col">
                  <div className="h-40 overflow-hidden bg-showty-pink/30">
                    <img src={p.img} alt={p.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="p-5 flex flex-col flex-1">
                    <h3 className="font-display text-xl text-showty-navy">{p.name}</h3>
                    <p className="mt-1.5 text-sm text-muted-foreground line-clamp-2">{p.desc}</p>
                    <div className="mt-3 rounded-lg bg-showty-cream border border-border px-3 py-2">
                      <p className="text-[11px] uppercase tracking-wide text-showty-gold font-semibold">Barter</p>
                      <p className="text-xs text-showty-navy mt-0.5">{p.barter}</p>
                    </div>
                    <div className="mt-4 flex items-center justify-between">
                      <span className="text-xs text-muted-foreground">Stok: {p.stock}</span>
                      <Button size="sm" className="rounded-full bg-showty-red hover:bg-[#9e1f24] text-white">Request Sample</Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </TabsContent>

          <TabsContent value="requests" className="mt-6">
            <div className="space-y-3">
              <div className="rounded-xl border border-border bg-white p-4 flex items-center gap-4">
                <div className="w-12 h-12 rounded-lg overflow-hidden bg-showty-pink/30 shrink-0"><img src="/images/brand-products.webp" alt="" className="w-full h-full object-cover" /></div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-showty-navy truncate">Showty Velvet Lip Tint</p>
                  <p className="text-xs text-muted-foreground truncate">Mau bikin tutorial daily look</p>
                </div>
                <Badge variant="outline" className="gap-1 bg-green-100 text-green-700 border-green-200"><CheckCircle2 className="w-3 h-3" /> Disetujui</Badge>
              </div>
            </div>
          </TabsContent>

          <TabsContent value="submissions" className="mt-6">
            <div className="flex justify-end mb-4">
              <Button className="rounded-full bg-showty-navy hover:bg-showty-navy/90 text-white"><Plus className="w-4 h-4 mr-1.5" /> Submit Video</Button>
            </div>
            <div className="space-y-3">
              <div className="rounded-xl border border-border bg-white p-4">
                <div className="flex items-center justify-between gap-4">
                  <div className="min-w-0">
                    <p className="font-medium text-showty-navy truncate">Showty Velvet Lip Tint</p>
                    <p className="text-xs text-muted-foreground">TikTok · 2 link · 0 file</p>
                  </div>
                  <Badge variant="outline" className="gap-1 bg-showty-peach text-showty-navy border-showty-gold/40"><Clock className="w-3 h-3" /> Menunggu</Badge>
                </div>
                <div className="mt-2 flex flex-wrap gap-2">
                  <span className="inline-flex items-center gap-1 text-xs rounded-full bg-showty-cream border border-border px-3 py-1.5 text-showty-red"><Video className="w-3 h-3" /> tiktok.com/@kayla/1</span>
                  <span className="inline-flex items-center gap-1 text-xs rounded-full bg-showty-cream border border-border px-3 py-1.5 text-showty-red"><Video className="w-3 h-3" /> instagram.com/p/abc</span>
                </div>
              </div>
            </div>
          </TabsContent>

          <TabsContent value="forum" className="mt-6">
            <p className="text-sm text-muted-foreground mb-3">Ngobrol langsung dengan tim admin Showtynion.</p>
            <div className="flex flex-col h-[420px] rounded-2xl border border-border bg-white overflow-hidden">
              <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-showty-cream/40">
                <div className="flex justify-start"><div className="max-w-[75%] rounded-2xl px-4 py-2 bg-showty-navy text-white"><p className="text-[11px] opacity-75 mb-0.5">KOL Manager · Admin</p><p className="text-sm">Halo Kayla! Sample kamu sudah kami approve ya 🎉</p></div></div>
                <div className="flex justify-end"><div className="max-w-[75%] rounded-2xl px-4 py-2 bg-showty-red text-white"><p className="text-sm">Terima kasih kak! Konten aku upload minggu ini.</p></div></div>
              </div>
              <div className="p-3 border-t border-border flex gap-2">
                <input className="flex-1 rounded-md border border-input px-3 text-sm" placeholder="Tulis pesan…" readOnly />
                <Button className="rounded-full bg-showty-red text-white">Kirim</Button>
              </div>
            </div>
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
